'use client';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import getLocal from 'eco-design-reliance/getLocal';
import { useEffect, useState } from 'react';
import { originPlayload, regionCode } from '../MicrosoftChat/config';
import RightMicroChat from '../RightMicroChat';
import WebClientA from './WebClientA';

const OpenChatLocalesA = ['us', 'ca', 'au', 'za', 'uk', 'eu', 'de', 'fr', 'cn', 'jp'];

export default function ItemMicrosoftChat({ position, rightIconUrl, microsoftChatItemA = {} }: any) {
    const [payloadData, setPayloadData] = useState<any>({});
    const { locale } = getLocal();
    const [payloadReady, setPayloadReady] = useState<boolean>(false);

    const getAllLcwForLocale = async () => {
        // const urlStr = encodeURIComponent('origin=Official website&sitename=12');
        // console.log(`https://efcrm.ecoflow.com/api/LiveChat/GetAdaptive?${urlStr}`);
        try {
            setPayloadReady(false);
            const originParams = encodeURIComponent('Official website');
            const res = await fetch(
                `https://efcrm.ecoflow.com/api/LiveChat/GetAdaptive?origin=${originParams}&sitename=${regionCode[locale] || regionCode['us']}`,
            );
            const result = await res.json();
            setPayloadReady(true);
            if (result && Object.keys(result)?.length > 0) {
                setPayloadData(result);
                return;
            }
            setPayloadData(originPlayload);
        } catch (error) {
            setPayloadReady(true);
            setPayloadData(originPlayload);
        }
    };

    useEffect(() => {
        // 聊天直播或全局视频是很影响性能的,要等有用户操作之后再加载
        const initHandleA = () => {
            EcoDesignEventsBus.on('GlobalUserAction-end-global', () => {
                getAllLcwForLocale();
            });
        };
        initHandleA();
    }, []);

    return (
        <>
            {OpenChatLocalesA.includes(locale) && position === 'bottom' && (
                <div className="widget-bottom-wrap">
                    <WebClientA payloadReady={payloadReady} payloadData={payloadData} microsoftChatItemA={microsoftChatItemA} />
                </div>
            )}
            {OpenChatLocalesA.includes(locale) && position === 'right' && (
                <RightMicroChat payloadReady={payloadReady} rightIconUrl={rightIconUrl} payloadData={payloadData} />
            )}
        </>
    );
}
